/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentVersion {
    getFixupPrototypeFunction() { return AwsSsmDocumentVersion.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentVersion>): AwsSsmDocumentVersion {
        let obj = Object.assign(new AwsSsmDocumentVersion(), model);
        AwsSsmDocumentVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentVersion>): AwsSsmDocumentVersion {
        if (!model) return null;
        return AwsSsmDocumentVersion.newInstance(<AwsSsmDocumentVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentVersion) {
        if (!obj) return;

        models.AwsSsmDocumentVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentVersion): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.document_creation_time === "string") {
            this.document_creation_time = new Date(<string><any>this.document_creation_time);
        }
        if (this.parameters) {
            for (let val of this.parameters) {
                models.AwsSsmParameter.fixupPrototype(val);
            }
        }
        if (this.attachment_contents) {
            for (let val of this.attachment_contents) {
                models.AwsSsmContentAttachmentDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * A structure that includes attributes that describe a document attachment
     */
    content: string;

    /**
     * The document version
     */
    document_version: string;

    /**
     * The document format, either JSON or YAML
     */
    document_format: string;

    /**
     * A description of the document
     */
    description: string;

    /**
     * Document ID of SSM docs
     */
    document_id: string;

    /**
     * The date the SSM document was created
     */
    document_creation_time: Date;

    /**
     * The cryptographic hash value of the document content.
     */
    hash: string;

    /**
     * The hash algorithm used to calculate the hash value
     */
    hash_type: models.AwsSsmHashType;

    /**
     * The schema version
     */
    schema_version: string;

    /**
     * The target type defines the kinds of resources the document can run on. For example, /AWS::EC2::Instance
     */
    target_type: string;

    /**
     * Parameters specified in a Systems Manager document that run on the server
     */
    parameters: Array<models.AwsSsmParameter>;

    /**
     * The list of operating system (OS) platforms
     */
    os_types: Array<string>;

    /**
     * A description of the document attachments, including names, locations, sizes
     */
    attachment_contents: Array<models.AwsSsmContentAttachmentDetail>;

}
